export { BankIcons as SafetyPayBankIcons } from './bank-icons';
